module.exports = __webpack_public_path__ + "static/media/7.Complete Accesories.4efdff65.jpg";